import { useContext } from 'react';
import { LeadCloseContext, tLeadCloseContext } from './LeadClose.context';

/** LEA-50's one state: summaries, settings, the form and the last save (KTD20). */
export function useLeadClose(): tLeadCloseContext {
  return useContext(LeadCloseContext);
}
